import { PremiumStorageOption } from 'owa-premium-storage-option';
import { SubscriptionOption } from 'owa-subscription-option';
import { AdvancedSecurityOption } from 'owa-advanced-security-option';
import { getAccountInformation } from 'owa-storage-option';
var premiumDashboardSubCategory = {
    key: 'Premium',
    titleStringKey: 'optionSubcategory_premium',
    options: [PremiumStorageOption, SubscriptionOption, AdvancedSecurityOption],
    onSelected: function () {
        return getAccountInformation();
    },
};
export default premiumDashboardSubCategory;
//# sourceMappingURL=premiumDashboardSubCategory.js.map